<template>
  <el-row class="page-fitter">
    <el-popover placement="bottom-start" v-model="searchVisible">
      <el-form :model="fitter" ref="searchForm" label-width="100px">
        <el-form-item label="任务类型" prop="task_type">
          <el-select style="width: 100%;" v-model="fitter.task_type" placeholder="请选择" size="mini">
            <el-option label="多维数据" :value="1"></el-option>
            <el-option label="基本信息" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务状态" prop="task_status">
          <el-select style="width: 100%;" v-model="fitter.task_status" placeholder="请选择" size="mini">
            <el-option label="未执行" :value="0"></el-option>
            <el-option label="已完成" :value="1"></el-option>
            <el-option label="任务重复" :value="2"></el-option>
            <el-option label="执行中" :value="3"></el-option>
            <el-option label="未知格式" :value="4"></el-option>
            <el-option label="任务暂停" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据维度" prop="file_type">
          <el-select style="width: 100%;" v-model="fitter.file_type" placeholder="请选择" size="mini">
            <el-option label="裁判文书" value="裁判文书"></el-option>
            <el-option label="控制企业" value="控制企业"></el-option>
            <el-option label="对外投资" value="对外投资"></el-option>
            <el-option label="行政处罚" value="行政处罚"></el-option>
            <el-option label="基本信息" value="基本信息"></el-option>
            <el-option label="终本案件" value="终本案件"></el-option>
            <el-option label="标准信息" value="标准信息"></el-option>
            <el-option label="软件著作权" value="软件著作权"></el-option>
            <el-option label="备案网站" value="备案网站"></el-option>
            <el-option label="失信被执行人" value="失信被执行人"></el-option>
            <el-option label="总公司" value="总公司"></el-option>
            <el-option label="客户" value="客户"></el-option>
            <el-option label="供应商" value="供应商"></el-option>
            <el-option label="限制高消费" value="限制高消费"></el-option>
            <el-option label="被执行人" value="被执行人"></el-option>
            <el-option label="融资信息-创投融资" value="融资信息-创投融资"></el-option>
            <el-option label="分支机构" value="分支机构"></el-option>
            <el-option label="商标信息" value="商标信息"></el-option>
            <el-option label="经营范围" value="经营范围"></el-option>
            <el-option label="资质证书" value="资质证书"></el-option>
            <el-option label="荣誉" value="荣誉"></el-option>
            <el-option label="司法案件" value="司法案件"></el-option>
            <el-option label="专利信息" value="专利信息"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="handelClearSearch('searchForm')" size="mini">重置</el-button>
          <el-button type="primary" @click="submitForm('searchForm')" size="mini">查询</el-button>
        </el-form-item>
      </el-form>
      <el-button slot="reference" size="mini">筛选</el-button>
    </el-popover>
    <el-popover placement="bottom-start" v-model="refreshVisible">
      <div>
        <span>登记状态</span>
        <upload-task-view-refresh  view-type="登记状态"/>
      </div>
      <div>
        <span>省市区</span>
        <upload-task-view-refresh  view-type="省市区"/>
      </div>
      <div>
        <span>资质证书</span>
        <upload-task-view-refresh  view-type="资质证书"/>
      </div>
      <el-button slot="reference" size="mini">视图刷新</el-button>
    </el-popover>
  </el-row>
</template>

<script>
import UploadTaskViewRefresh from "../../intellectual_property/common/UploadTaskViewRefresh.vue";
export default {
  name: 'UploadTaskFitter',
  components: { UploadTaskViewRefresh },
  props: {
    fitter: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      searchVisible: false,
      refreshVisible: false
    }
  },
  methods: {
    handelClearSearch (formName) {
      this.$refs[formName].resetFields()
      this.searchVisible = false
      this.$emit('search', false)
    },
    submitForm(formName) {
      this.searchVisible = false
      this.$emit('search', false)
    },
    resetForm (formName) {
    },
    handleSearch (search) {
      this.$emit('search', false)
    }
  }
}
</script>

<style lang="stylus" scoped>
.page-fitter >>> .el-input {
  width: auto;
}
.el-form-item {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/upload_tasks/common/UploadTaskFitter.vue